export default {
    autoBind: Boolean, 
    axisDefaults: Object, 
    categoryAxis: Array | Object, 
    chartArea: Object, 
    dataSource: Object | Array, 
    legend: Object, 
    panes: Array | Object, 
    pannable: Boolean | Object, 
    pdf: Object, 
    plotArea: Object, 
    renderAs: String, 
    series: Array, 
    seriesColors: Array, 
    seriesDefaults: Object, 
    theme: String, 
    title: String | Object, 
    tooltip: Object, 
    transitions: Boolean, 
    valueAxis: Array | Object, 
    xAxis: Array | Object, 
    yAxis: Array | Object, 
    zoomable: Boolean | Object, 

    // Events
    axisLabelClick: Function, 
    dataBound: Function, 
    drag: Function, 
    dragEnd: Function, 
    dragStart: Function, 
    legendItemClick: Function, 
    legendItemHover: Function, 
    noteClick: Function, 
    noteHover: Function, 
    plotAreaClick: Function, 
    plotAreaHover: Function, 
    render: Function, 
    select: Function, 
    selectEnd: Function, 
    selectStart: Function, 
    seriesClick: Function, 
    seriesHover: Function, 
    zoom: Function, 
    zoomEnd: Function, 
    zoomStart: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/ChartProps.js